const SidebarHelper = {
    // ---- methods ----
    resolvePermissionMenuPath: (fePath) => {
        const parts = (fePath || '').split('/').filter(Boolean);
        if (parts.length === 0) return null;

        if (parts.length === 1) {
            return `/${parts[0]}`;
        }

        return '/' + parts.slice(0, -1).join('/');
    },

    filterMenuItemByPermission: (item, formattedPermissionList) => {
        if (item?.type !== 'item' || item?.show === false) return null;

        if (item?.subMenuItems) {
            const filteredSubMenuItems = item.subMenuItems.filter((subMenuItem) =>
                formattedPermissionList?.includes(subMenuItem?.path)
            );

            if (filteredSubMenuItems.length > 0) {
                return { ...item, subMenuItems: filteredSubMenuItems };
            }
            return null;
        }

        return formattedPermissionList?.includes(item?.path) ? item : null;
    },

    checkPermissionList: (items, permissionList) => {
        if (!permissionList?.length) return items;

        const formattedPermissionList = [
            ...new Set(
                permissionList?.map((permission) =>
                    SidebarHelper.resolvePermissionMenuPath(permission?.path)
                )
            )
        ].filter(Boolean);

        const result = [];
        let pendingSection = null;

        items?.forEach((item) => {
            if (item?.type === 'section') {
                if (item?.show === undefined || item?.show) {
                    pendingSection = item;
                }
                return;
            }

            const filteredItem = SidebarHelper.filterMenuItemByPermission(item, formattedPermissionList);
            if (!filteredItem) return;

            if (pendingSection) {
                result.push(pendingSection);
                pendingSection = null;
            }
            result.push(filteredItem);
        });

        return result;
    },

};

export default SidebarHelper;
